import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/folder': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 128c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h146.7c8.5 0 16.6 3.4 22.6 9.4l54.6 54.6h192zM464 400v-224h-198.6c-8.5 0-16.6-3.4-22.6-9.4l-54.6-54.6h-140.1v288h416z'
      }
    ]
  }
})
